'use client';

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../contexts/ApiContext';
import { queryKeys } from '../../../lib/queryClient';
import { useIsAuthed } from '../../../hooks/useIsAuthed';
import type {
  MergedAchievement,
  MergedAchievementsResponse,
} from '../../../services/generated/Api';

export type { MergedAchievement, MergedAchievementsResponse };

export interface MyAchievementsOptions {
  onlyUnlocked?: boolean;
  hideLockedSecrets?: boolean;
}

export function useMyAchievements(opts: MyAchievementsOptions = {}) {
  const api = useApiClient();
  const isAuthed = useIsAuthed();

  return useQuery({
    queryKey: [...queryKeys.achievementsMine, opts.onlyUnlocked ?? false, opts.hideLockedSecrets ?? false],
    queryFn: () =>
      api.api.achievementsControllerGetMy({
        onlyUnlocked: opts.onlyUnlocked,
        hideLockedSecrets: opts.hideLockedSecrets,
      }),
    enabled: isAuthed,
    staleTime: 5 * 60 * 1000,
  });
}
